import * as React from "react";
import { forwardRef } from "react";
const SvgSend = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 10 10", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8 9.33342L10 0L0 3.33341L3.33333 5.33342L8 2.00008L4.33333 6.00008L8 9.33342Z" }));
const ForwardRef = forwardRef(SvgSend);
export { ForwardRef as ReactComponent };
